import { render, staticRenderFns } from "./credit_worthy.vue?vue&type=template&id=4c6fed4c&scoped=true&"
import script from "./credit_worthy.vue?vue&type=script&lang=js&"
export * from "./credit_worthy.vue?vue&type=script&lang=js&"
import style0 from "./credit_worthy.vue?vue&type=style&index=0&id=4c6fed4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6fed4c",
  null
  
)

export default component.exports